<!-- <h1 mat-dialog-title>{{ 'LoginModal.AccountRegistration' | translate }}</h1> -->
<div mat-dialog-content style="padding: 24px; border-radius: 4px; width: 100%; height: 100%; min-height: inherit; max-height: inherit;
">
  <h1>{{ 'CookiePopup.CookieHeader' | translate }}  </h1>
  <p> {{ 'CookiePopup.CookieContent' | translate }}
  <a *ngIf="isCanadaPortal" style="outline:none;" href="{{this.localRedirect}}home/useAndPrivacy">{{ 'Footer.TermsandConditions' | translate }}</a>
  <a *ngIf="!isCanadaPortal" style="outline:none;"href="home/useAndPrivacy">{{ 'Footer.TermsandConditions' | translate }}</a>
</p>
<button type="submit" (click)="enableGA($event,'false')" style="float: left;" class="mbfs-button">{{ 'CookiePopup.CookieButton1' | translate }}</button>
<button type="submit" (click)="enableGA($event,'true')"  (keyup.enter)="enableGA($event,'true')" style="float: right;" class="mbfs-button">{{ 'CookiePopup.CookieButton2' | translate }}</button>
</div>


<!-- <div mat-dialog-actions>
  <button class="mbfs-button" mat-dialog-close>Agree to All</button>
</div> -->